const signupInputClass = "w-full";
export const SIGNUP_FIELDS = [
    {
        label: "First Name",
        name: "first_name",
        type: "text",
        css: signupInputClass,
    },
    {
        label: "Last Name",
        name: "last_name",
        type: "text",
        css: signupInputClass,
    },
    { label: "Email address", name: "email", type: "email", css: "w-full" },
    {
        label: "Mobile no.",
        name: "mobile",
        type: "text",
        css: "w-full",
        maxLength: 10,
    },
];

export const USER_ROLE_FIELDS = [
    { label: "Site Staff", name: "role", value: "SITESTAFF" },
    { label: "Site Manager", name: "role", value: "SITEMANAGER" },
    { label: "HO", name: "role", value: "HO" },
    { label: "Admin", name: "role", value: "ADMIN" }
];

export const DEFAULT_USER_ROLE = "SITESTAFF"

export const MESSAGES = {
    LOGIN_SUCCESS: "Login Successful",
    LOGIN_FAILURE: "Incorrect email or password",
    SIGN_UP_SUCCESS: "Sign up successful. Please Login!",
    SIGN_UP_FAILED: "Sign up Failed. Contact Admin!",
    SIGN_UP_ERROR: "An error occurred during sign up. Please try again.",
    MOBILE_VALIDATION: "Enter a valid 10-digit mobile number",
    PASSWORD_VALIDATION: "Password must be at least 6 characters",
    PIN_VALIDATION: "Password must be a 4-digit PIN",
    REQUIRED: "Required",
    SESSION_TIMEOUT: "Session Timeout",
};